import {
  AccountInfo,
  InteractionRequiredAuthError,
  InteractionStatus,
  IPublicClientApplication,
} from '@azure/msal-browser';
import {
  employeeSignInAuthority,
  getApiAccessRequest,
  getApiAccessRequestSilent,
  signInAuthority,
  wellsFargoSignInAuthority,
} from 'authConfig';
import { authorizeUser } from 'pages/Login';
import { Dispatch } from 'redux';

export const getAccessToken = (
  instance: IPublicClientApplication,
  account: AccountInfo | null,
  inProgress: InteractionStatus,
) => {
  const isPublicUser = localStorage.getItem('ispublicuser') !== 'false';
  const isWellsFargoUser = localStorage.getItem('iswellsfargouser') === 'true';
  const accessTokenRequestAuthority = isPublicUser
    ? isWellsFargoUser
      ? wellsFargoSignInAuthority
      : signInAuthority
    : employeeSignInAuthority;

  return instance
    .acquireTokenSilent(
      getApiAccessRequestSilent(account, accessTokenRequestAuthority),
    )
    .catch((error) => {
      // in case if silent token acquisition fails, fallback to an interactive method
      if (error instanceof InteractionRequiredAuthError) {
        if (account && inProgress === InteractionStatus.None) {
          instance.acquireTokenRedirect(
            getApiAccessRequest(accessTokenRequestAuthority),
          );
          // returning the callback promise associated with the acquire token redirect method
          return instance.handleRedirectPromise();
        }
      }
    });
};

export const logoutAdUser = (instance: IPublicClientApplication) => {
  localStorage.removeItem('user');
  localStorage.removeItem('refreshadusersession');
  localStorage.removeItem('ispublicuser');
  localStorage.removeItem('iswellsfargouser');
  instance.logoutRedirect();
};

export const invalidUserRedirectWithError = (
  instance: IPublicClientApplication,
) => {
  logoutAdUser(instance);
};

export const refreshAdUserSession = (
  instance: IPublicClientApplication,
  account: AccountInfo | null,
  dispatch: Dispatch,
  postAuthorizationAction: (...args: unknown[]) => unknown,
  preAuthorizationAction?: (...args: unknown[]) => unknown,
) => {
  if (preAuthorizationAction) {
    preAuthorizationAction();
  }
  getAccessToken(instance, account, InteractionStatus.None)
    .then((response) => {
      if (response?.accessToken)
        // if user doesn't exist in our databse, authorize user will throw an error which we catch below
        authorizeUser(response?.accessToken, dispatch, instance)
          .then(() => {
            postAuthorizationAction();
          })
          .catch(() => {
            // failed to authorize user
            logoutAdUser(instance);
          });
    })
    .catch(() => {
      // failed to retrieve access token
      logoutAdUser(instance);
    });
};

// TODO started looking for a way to further refactor and remove boilerplate code for api requests that use the new azure ad access tokens
// however, still now sure if this is worth it if it makes the code less readable. Also, this still doesn't handle access tokens that call multiplle requests
// at once or api requests that accept parameters. Keeping it here in case we decide to try to implement this further
// export const fetchWithAccessToken = (
//   dispatch: Dispatch<any>,
//   legacyToken: string,
//   instance: IPublicClientApplication,
//   account: AccountInfo | null,
//   inProgress: InteractionStatus,
//   apiRequestMethod: Function,
//   apiData: any,
// ) => {
//   const isPublicUser = getCookie('ispublicuser') !== 'false';
//   const accessTokenRequestAuthority = isPublicUser ? signInAuthority : employeeSignInAuthority;
//   if (legacyToken && apiData === null) {
//     dispatch(apiRequestMethod(legacyToken));
//   } else if (account && inProgress === InteractionStatus.None && apiData === null) {
//     instance.acquireTokenSilent(getApiAccessRequestSilent(account, accessTokenRequestAuthority)).then((response) => {
//       dispatch(apiRequestMethod(response.accessToken));
//     }).catch((error) => {
//       // in case if silent token acquisition fails, fallback to an interactive method
//       if (error instanceof InteractionRequiredAuthError) {
//         if (account && inProgress === InteractionStatus.None) {
//           instance.acquireTokenPopup(getApiAccessRequest(accessTokenRequestAuthority)).then((response) => {
//             dispatch(apiRequestMethod(response.accessToken));
//           }).catch(error => console.log(error));
//         }
//       }
//     });
//   }
// };
